import { Option, Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import { FormInput } from '../../shared-components/form/FormInput';
import { SelectOptions } from '../../shared-components/form/SelectOptions';
import { ValidationMessageList } from '../../shared-components/ValidationMessageList';

interface NominationNameDetailFormProps {
  isViewOnly: boolean;
}

const NominationNameDetailFormImpl: React.FC<NominationNameDetailFormProps> = (props) => {
  const {
    isViewOnly,
  } = props;

  const {
    nominationForStaffPageUiStore,
  } = useStores();

  return (
    <FlexBox
      isFullWidth
      as='section'
      className='nomination-details__fields'
    >
      <Text
        as='h3'
        block
        weight='semibold'
      >
        Your Information
      </Text>
      <FlexBox
        isFullWidth
        direction='column'
        className='fields__list'
      >
        <FlexBox isFullWidth aligns='start'>
          <CommonLabelAndValueList
            labelId='nomination-name'
            label='Solution name:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.name}
          >
            {
              !isViewOnly &&
              <FormInput
                validationMessage={
                  nominationForStaffPageUiStore.nominationSubmissionValidation.fieldErrors.name?.length
                    ? <ValidationMessageList messages={nominationForStaffPageUiStore.nominationSubmissionValidation.fieldErrors.name} />
                    : undefined
                }
                onChange={name => nominationForStaffPageUiStore.nominationForStaff.nomination.name = name}
                inputProps={{
                  'aria-labelledby': 'nomination-name',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.name,
                  maxLength: 100,
                }}
              />
            }
          </CommonLabelAndValueList>
        </FlexBox>
        <FlexBox isFullWidth aligns='start'>
          <CommonLabelAndValueList
            labelId='prefix'
            label='Prefix:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.owner.prefix}
          >
            {
              !isViewOnly &&
              <SelectOptions
                onOptionSelect={(data) => nominationForStaffPageUiStore.setOwnerBodyRequest('prefix', data.optionValue || undefined)}
                dropdownProps={{
                  'aria-labelledby': 'prefix',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.prefix || '',
                  selectedOptions: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.prefix
                    ? [nominationForStaffPageUiStore.nominationForStaff.nomination.owner.prefix]
                    : [],
                }}
              >
                <Option text='' />
                <Option value='Mr.'>Mr.</Option>
                <Option value='Mrs.'>Mrs.</Option>
                <Option value='Ms.'>Ms.</Option>
              </SelectOptions>
            }
          </CommonLabelAndValueList>
          <CommonLabelAndValueList
            labelId='first-name'
            label='First name:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.owner.firstName}
          >
            {
              !isViewOnly &&
              <FormInput
                validationMessage={
                  nominationForStaffPageUiStore.yourInformationValidation.fieldErrors.firstName?.length
                    ? <ValidationMessageList messages={nominationForStaffPageUiStore.yourInformationValidation.fieldErrors.firstName} />
                    : undefined
                }
                onChange={firstName => nominationForStaffPageUiStore.setOwnerBodyRequest('firstName', firstName)}
                inputProps={{
                  'aria-labelledby': 'first-name',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.firstName,
                  maxLength: 100,
                }}
              />
            }
          </CommonLabelAndValueList>
        </FlexBox>
        <FlexBox isFullWidth aligns='start'>
          <CommonLabelAndValueList
            labelId='last-name'
            label='Last name:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.owner.lastName}
          >
            {
              !isViewOnly &&
              <FormInput
                validationMessage={
                  nominationForStaffPageUiStore.yourInformationValidation.fieldErrors.lastName?.length
                    ? <ValidationMessageList messages={nominationForStaffPageUiStore.yourInformationValidation.fieldErrors.lastName} />
                    : undefined
                }
                onChange={lastName => nominationForStaffPageUiStore.setOwnerBodyRequest('lastName', lastName)}
                inputProps={{
                  'aria-labelledby': 'last-name',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.lastName,
                  maxLength: 100,
                }}
              />
            }
          </CommonLabelAndValueList>
          <CommonLabelAndValueList
            labelId='title'
            label='Title / Role:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.owner.title}
          >
            {
              !isViewOnly &&
              <FormInput
                onChange={title => nominationForStaffPageUiStore.setOwnerBodyRequest('title', title || undefined)}
                inputProps={{
                  'aria-labelledby': 'title',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.title || '',
                  maxLength: 100,
                }}
              />
            }
          </CommonLabelAndValueList>
        </FlexBox>
        <FlexBox isFullWidth aligns='start'>
          <CommonLabelAndValueList
            labelId='email'
            label='Email:'
            childrenFallback={nominationForStaffPageUiStore.nominationForStaff.nomination.owner.emailAddress}
          >
            {
              !isViewOnly &&
              <FormInput
                validationMessage={
                  nominationForStaffPageUiStore.nominationOwnerEmailValidation.fieldErrors.emailAddress?.length
                    ? <ValidationMessageList messages={nominationForStaffPageUiStore.nominationOwnerEmailValidation.fieldErrors.emailAddress} />
                    : undefined
                }
                onChange={emailAddress => nominationForStaffPageUiStore.setOwnerBodyRequest('emailAddress', emailAddress)}
                inputProps={{
                  'aria-labelledby': 'email',
                  value: nominationForStaffPageUiStore.nominationForStaff.nomination.owner.emailAddress,
                  maxLength: 100,
                }}
              />
            }
          </CommonLabelAndValueList>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  )
}

export const NominationNameDetailForm = observer(NominationNameDetailFormImpl);
